import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'
import './styles/embed.css'
import { registerServiceWorker } from './lib/serviceWorker'

const isProduction = import.meta.env.PROD

Sentry.init({
  dsn: "https://ec9fa22b7f7b4ce5d09d6911a1c8fa41@o4510904285986816.ingest.us.sentry.io/4510904287232000",
  environment: isProduction ? 'production' : 'development',
  enabled: isProduction,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.httpClientIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/bqitfhvaejxcyvjszfom\.supabase\.co/,
    /^https:\/\/api\.aspronetlabs\.com/,
  ],
  beforeSend(event) {
    // Filter out noisy browser extension errors
    if (event.exception?.values?.some(e => e.stacktrace?.frames?.some(f => f.filename?.includes('extension://')))) {
      return null
    }
    return event
  },
});

// OPTIMIZED: Register service worker for offline caching (production only)
registerServiceWorker()

createRoot(document.getElementById("root")!).render(<App />);
